import { useCallback, useEffect } from 'react';

import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { CalendarWrapper as Calendar } from '@/components/common/calendar-wrapper';
import { useSites } from '@/services/sites';
import { formatDateWithPattern } from '@/utils';

import { useSemenPullContext } from './useSemenPullContext';

export const SemenPullSelector = () => {
  const { t } = useTranslation();
  const { sites, setSites, selectedSite } = useSemenPullContext();
  const [params, setParams] = useSearchParams();
  const donorScheduleDate = params.get('date');

  const { data: siteData } = useSites({ filter: 'fertilization' });

  useEffect(() => {
    if (siteData) {
      setSites(siteData);
    }
  }, [setSites, siteData]);

  const handleDateChange = useCallback(
    (e: DropdownChangeEvent) => {
      const newParams = new URLSearchParams(params);
      if (e.value) {
        newParams.set('date', formatDateWithPattern(e.value, 'MM-dd-yyyy'));
      } else {
        newParams.delete('date');
      }
      setParams(newParams);
    },
    [params, setParams],
  );

  const handleSiteChange = useCallback(
    (e: DropdownChangeEvent) => {
      const newParams = new URLSearchParams(params);
      if (e.value) {
        newParams.set('site', e.value.id);
      } else {
        newParams.delete('site');
      }
      setParams(newParams);
    },
    [params, setParams],
  );
  return (
    <div className="flex gap-2">
      <div className="flex min-w-60 flex-1 flex-col">
        <Calendar
          value={donorScheduleDate ? new Date(donorScheduleDate) : null}
          dateFormat="mm-dd-yy"
          placeholder={t('donorScheduling.donorScheduleDate')}
          onChange={handleDateChange}
          showIcon
        />
      </div>
      <div className="flex min-w-60 flex-1 flex-col">
        <Dropdown
          value={selectedSite}
          placeholder={t('fertilization.fertilizationSite')}
          onChange={handleSiteChange}
          options={sites || []}
          disabled={!donorScheduleDate}
          optionLabel="name"
          className="location-dropdown"
        />
      </div>
    </div>
  );
};
